
import { Component, Mixins } from "vue-property-decorator";
import AuthMixin from "@/common/mixins/auth.mixin";
import { mapState } from "vuex";
import { ResetPasswordFormDto } from "@/types/user.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

@Component({
  computed: {
    ...mapState("Auth", ["errorMessage"])
  }
})
export default class NewPassword extends Mixins(AuthMixin, ValidatedFormMixin) {
  form: ResetPasswordFormDto = new ResetPasswordFormDto();
  passwordShow = false;
  confirmShow = false;
  loading = false;

  errorMessage!: string;

  viewPassword(): void {
    this.passwordShow = !this.passwordShow;
  }

  viewConfirm(): void {
    this.confirmShow = !this.confirmShow;
  }

  mounted(): void {
    this.form =  {
      token: this.$route.params.token,
      email: this.$route.params.email,
      password: ""
    }
  }

  closeModal(): void {
    this.$router.push("/login");
  }

  async submit(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        await this.$store.dispatch("Auth/resetPassword", this.form);
        
        this.$router.replace("/login")

        this.loading = false;
      }   
    });
  }
}
